/**
 * VersionSwitcher — a small dropdown to flip between the live gallery (Prompt-Brush 2.0,
 * at /gallery) and the original book archive (Prompt-Brush 1.0, at /collection).
 * Sits next to the search bar on both pages.
 */

import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const MONO = 'FK Grotesk Mono, monospace';

export function VersionSwitcher({ current }: { current: '1.0' | '2.0' }) {
  const navigate = useNavigate();
  return (
    <div className="relative shrink-0">
      <select
        value={current}
        onChange={(e) => {
          const v = e.target.value;
          if (v === current) return;
          navigate(v === '1.0' ? '/collection' : '/gallery');
        }}
        aria-label="Switch between Prompt-Brush 2.0 and 1.0"
        className="appearance-none h-10 rounded-[20px] border border-border bg-card pl-4 pr-9 text-foreground text-sm cursor-pointer focus:border-primary focus:outline-none"
        style={{ fontFamily: MONO }}
      >
        <option value="2.0">Prompt-Brush 2.0</option>
        <option value="1.0">Prompt-Brush 1.0</option>
      </select>
      <ChevronDown
        className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none"
        aria-hidden="true"
      />
    </div>
  );
}
